import React from "react";
import { Routes, Route } from "react-router-dom";
import { AllElements } from "./allElements";

function App() {
  return (
    <Routes>
      <Route path="/login" element={<AllElements.Login />} />
      <Route
        path="/otp-verification"
        element={<AllElements.OTPVerification />}
      />
      <Route
        path="/get-password-reset-mail"
        element={<AllElements.GetPasswordResetMail />}
      />
      <Route path="/password-reset" element={<AllElements.ResetPassword />} />
      <Route path="/500" element={<AllElements.ServerError />} />
      <Route path="/unauthorized" element={<AllElements.Unauthorized />} />
      <Route
        path="*"
        element={
          <AllElements.DefaultLayout>
            <Routes>
              <Route index element={<AllElements.SellPoints />} />

              {/* Route pour les entrepôts - accessible selon les permissions stock */}
              <Route path="/redirect" element={<AllElements.LoginRedirect />} />
              <Route
                path="/stock"
                element={
                  <AllElements.ProtectedRoute
                    requiredPermissions={[
                      "canViewAllStock",
                      "canViewAllWarehouses",
                    ]}
                  >
                    <AllElements.Entropots />
                  </AllElements.ProtectedRoute>
                }
              />

              <Route
                path="/stock/sell-point-details/:id"
                element={
                  <AllElements.ProtectedRoute
                    requiredPermissions={[
                      "canViewAllStock",
                      "canViewAssignedStock",
                    ]}
                  >
                    <AllElements.SellPointDetails />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/stock/sell-point-details/:pdv_id/category/:id"
                element={
                  <AllElements.ProtectedRoute
                    requiredPermissions={[
                      "canViewAllStock",
                      "canViewAssignedStock",
                    ]}
                  >
                    <AllElements.Category />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/stock/edit-product/:id"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canManageStock">
                    <AllElements.EditProduct />
                  </AllElements.ProtectedRoute>
                }
              />

              {/* Routes pour les clients */}
              <Route
                path="/clients"
                element={
                  <AllElements.ProtectedRoute
                    requiredPermissions={[
                      "canViewAllClients",
                      "canViewAssignedClients",
                    ]}
                  >
                    <AllElements.ClientsOverview />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/clients/particuliers"
                element={
                  <AllElements.ProtectedRoute
                    requiredPermissions={[
                      "canViewAllClients",
                      "canViewAssignedClients",
                    ]}
                  >
                    <AllElements.SimpleClients />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/clients/particuliers/add"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canCreateClient">
                    <AllElements.ClientAddForm />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/sales/nouveau-client-particulier"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canCreateSale">
                    <AllElements.ParticularAddFacture />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/sales/nouveau-client-pro"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canCreateSale">
                    <AllElements.ProfessionalsAddFacture />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/clients/particuliers/edit/:id"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canEditClient">
                    <AllElements.ClientEditForm />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/clients/particuliers/show/:id"
                element={
                  <AllElements.ProtectedRoute
                    requiredPermissions={[
                      "canViewAllClients",
                      "canViewAssignedClients",
                    ]}
                  >
                    <AllElements.Particulier />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/clients/professionnels"
                element={
                  <AllElements.ProtectedRoute
                    requiredPermissions={[
                      "canViewAllClients",
                      "canViewAssignedClients",
                    ]}
                  >
                    <AllElements.Professionals />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/clients/professionnels/add"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canCreateClient">
                    <AllElements.ProfessionalsAddForm />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/clients/professionnels/show/:id"
                element={
                  <AllElements.ProtectedRoute
                    requiredPermissions={[
                      "canViewAllClients",
                      "canViewAssignedClients",
                    ]}
                  >
                    <AllElements.Professional />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/clients/professionnels/edit/:id"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canEditClient">
                    <AllElements.ProfessionalsEditForm />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/commercials"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canViewAllCommercials">
                    <AllElements.Commercials />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/commercials/add"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canCreateCommercial">
                    <AllElements.AddCommercialForm />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/commercials/edit/:id"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canEditCommercial">
                    <AllElements.EditCommercialForm />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/commercials/details/:id"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canViewAllCommercials">
                    <AllElements.CommercialDetails />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/prospects"
                element={
                  <AllElements.ProtectedRoute
                    requiredPermissions={[
                      "canViewAllProspects",
                      "canViewAssignedProspects",
                    ]}
                  >
                    <AllElements.Prospects />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/prospects/details/:id"
                element={
                  <AllElements.ProtectedRoute
                    requiredPermissions={[
                      "canViewAllProspects",
                      "canViewAssignedProspects",
                    ]}
                  >
                    <AllElements.ProspectDetails />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/prospects/add"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canCreateProspect">
                    <AllElements.ProspectAddForm />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/prospects/edit/:id"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canEditProspect">
                    <AllElements.ProspectEditForm />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="sales"
                element={
                  <AllElements.ProtectedRoute
                    requiredPermissions={[
                      "canViewAllSales",
                      "canViewAssignedSales",
                    ]}
                  >
                    <AllElements.Facture />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/sales/add"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canCreateSale">
                    <AllElements.FactureAddForm />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/sales/details/:id"
                element={
                  <AllElements.ProtectedRoute
                    requiredPermissions={[
                      "canViewAllSales",
                      "canViewAssignedSales",
                    ]}
                  >
                    <AllElements.FactureDetails />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/sales-factures/:id"
                element={
                  <AllElements.ProtectedRoute
                    requiredPermissions={[
                      "canViewAllSales",
                      "canViewAssignedSales",
                    ]}
                  >
                    <AllElements.Facture />
                  </AllElements.ProtectedRoute>
                }
              />
              {/* Routes pour les utilisateurs */}
              <Route
                path="/users"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canManageUsers">
                    <AllElements.Users />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/users/add"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canManageUsers">
                    <AllElements.UserAddForm />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/users/edit/:id"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canManageUsers">
                    <AllElements.UserEditForm />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/users/details/:id"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canManageUsers">
                    <AllElements.UserDetails />
                  </AllElements.ProtectedRoute>
                }
              />

              <Route path="/profile" element={<AllElements.Profile />} />
              <Route path="/logout" element={<AllElements.Logout />} />
              <Route path="*" element={<AllElements.NotFound />} />

              <Route
                path="/autres-sorties"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canCreateStockOutflow">
                    <AllElements.StockOutflowApp />
                  </AllElements.ProtectedRoute>
                }
              />
              <Route
                path="/autres-entrees"
                element={
                  <AllElements.ProtectedRoute requiredPermissions="canCreateStockEntry">
                    <AllElements.StockEnterflowApp />
                  </AllElements.ProtectedRoute>
                }
              />
            </Routes>
          </AllElements.DefaultLayout>
        }
      />
    </Routes>
  );
}

export default App;
